import { Box, Image } from "@chakra-ui/react";
import imgContent from "../../../assets/images/content/bg/content-benefit.png";
import tContent from "../../../assets/images/content/bg/content-tablet-benefit.png";
import mContent from "../../../assets/images/content/bg/content-mobile-benefit.png";

import { useContext } from "react";
import { ScreenContext } from "../../../components/ScreenProvider";


const Benefit = () => {
  const screen = useContext(ScreenContext).style;
  const contents = {
    pc: imgContent,
    mobile: mContent,
    tablet: tContent,
  };

  return (
    <Box w={"100%"}>
      <Image 
        src={contents[screen]} 
        w={"100%"} 
        alt="" 
      />
    </Box>
  );
};

export default Benefit;